$(document).ready(function(){

  var store_id = 0;
  var allowedDay = "";
  getstoreinfo();

  $(".direct_virutal").change(function(){
    var $this = $(this);
    var input = $(".direct_fields_address :input");
    if($this.val() == "Virtual"){
      $(".direct_fields_address").fadeIn();
      input.attr('required','required');
      $(".book_direct_ship2").removeAttr('required');
    }else{
      $(".direct_fields_address").fadeOut();
      input.removeAttr('required');
      input.val('')
    }
  });

  $(".slot_virutal").change(function(){
    var $this = $(this);
    var input = $(".slot_fields_address :input");
    if($this.val() == "Virtual"){
      $(".slot_fields_address").fadeIn();
      input.attr('required','required');
      $(".book_ship2").removeAttr('required');
    }else{
      $(".slot_fields_address").fadeOut();
      input.removeAttr('required');
      input.val('')
    }
  });

  $(".plus").click(function() {
    var val = parseInt($(".numberquty").val(), 10) || 0;
    if (val < 10) {
      val++;
      $(".numberquty").val(val);
    }
  });

  $(".minus").click(function() {
    var val = parseInt($(".numberquty").val(), 10) || 0;
    if (val > 5) { // Keeps your min limit at 5
      val--;
      $(".numberquty").val(val);
    }
  });
  
    var selected_date = '';
    var slot_book = '';
    var store_id ='';
    var booking_type='';
    var booking_type_form='';
    var members = 1;
    var store_name='';
    var store_address='';
    //var allowedDay = "2025-12-29";
    //var allowedDay = "";
    var dateObject = $( "#datepicker" ).datepicker({
      dateFormat: 'mm/dd/yy',
      minDate: 0, 
      //beforeShowDay: noMondays,
      onSelect: function(dateText, inst) { 
        var date_selected = dateText;        
        $("#selectd_appointment_date").val(date_selected);
        selected_date = date_selected;
        slot_book='';
        $(".confirm_member_appointment").hide();
        getSlots();
     }
      
    });    

    function noMondays(date) {
      var day = date.getDay(); // 1 = Monday

      // format date to yyyy-mm-dd
      var formattedDate = date.getFullYear() + "-" +
          String(date.getMonth() + 1).padStart(2, '0') + "-" +
          String(date.getDate()).padStart(2, '0');

      // if Monday AND not the allowed Monday → disable
      if (day === 1 && formattedDate !== allowedDay) {
          return [false, "closed", "Closed on Monday"];
      }

      // otherwise enable
      return [true, "", ""];
  }
  
    var init_date = $("#datepicker").datepicker( {dateFormat: 'dd-mm-yy'} ).val();
    $("#selectd_appointment_date").val(init_date);
    selected_date = init_date;

    $('body').on("click",".confirm_store",function(){
      var $this = $(this);
      $("#store_id_"+$this.attr('data-id')).show();
      store_id = $this.attr('data-id');
      store_name = $this.attr('data-store');
      store_address = $this.attr('data-storecountry') +": "+ $this.attr('data-storeaddress');

      $(".stores_list").hide();
      target_scroll('lab');
        
    });

    function target_scroll(dentifier){
      // $('html, body').animate({
      //   scrollTop: eval($('.'+dentifier).offset().top - 100)
      //   }, 2000);
      $('html, body').animate({ scrollTop:100 },"fast");
    }
    $("body").on("click",".back_member_first",function(e){
      e.preventDefault();
      $(".lab").hide();
      $(".confirm_member_container_first").hide();
      $(".number_guest_info").hide();
      $('.box-information-container').hide();
      $(".form_appointment_container").hide();  
      // $('.box-information-container').hide();
      $('.stores_list').show();
      target_scroll('stores_list');
    });

    

    $("body").on("change",".number_guest_info",function(e){
      e.preventDefault();
      var $this = $(this);     
      members = $this.val();   
    });

    $("body").on("click",".back_member_appointment",function(e){
      $(".calender_appointment_container").hide();
      $(".store_inner").show();
      target_scroll('store_inner');
    });

    $("body").on("click",".back_direct_form",function(e){
      $(".form_appointment_container").hide();
      $(".store_inner").show();
      $(".lab").show();
      target_scroll('store_inner');
    });

    

    $("body").on("click",".appointment_form_submit_back",function(e){
      $(".calender_slots_form_submit").hide();
      $(".calender_slots").show();
      target_scroll('calender_slots');
    });

    

    $('body').on("click",".comming_modules",function(){
      $(".number_guest_info").hide();
      $('.box-information-container').hide();
      $(".form_appointment_container").hide();  
      $('.box-information-container').hide();
      $(".number_guest_info").hide();
      var $this = $(this);
      booking_type_form = $this.attr('data-numbers');
      //members = $this.attr('data-numbers');
      //console.log("Member run "+members)

      /****Title CONTENT SCRIPT******/
      $('.formtype').hide();
      $(".formtype_"+booking_type_form).show();
      
      
      $('.box-information-container').hide();
      if($this.attr('data-type') =="1"){
        
        
        if($this.attr('data-discription')!=0){
          //$this.children('.box-information-container').show();
          
          $(".box-related-"+booking_type_form).show();
        }
        if($this.attr('data-numbers') > 1){
          $(".number_guest_info").show();
        }
        $(".confirm_member_container_first").show();
        booking_type = 'slot_booking'; 
        
        //target_scroll('confirm_member_container');
      }else{
        $('.lab').hide();
        $(".calender_appointment_container").hide();
        $(".form_appointment_container").show();
        $(".confirm_member_container_first").hide();
        booking_type = 'direct_booking';
        target_scroll('form_appointment_container');
      }
    });

    $('body').on('click','.confirm_member',function(){     
          $(".store_inner").hide();
          $(".form_appointment_container").hide();
          $(".calender_appointment_container").show();
        
         getSlots();
         target_scroll('calender_appointment_container');
                 
    });

    $('body').on('click','.slots_input',function(){
      var $this = $(this);
      slot_book = $this.attr('data-slot');
      $(".time_calander").children('.list-1').removeClass('active')
      $this.parent().addClass('active');
      //console.log(" SLOTS "+$this.attr('data-slot'));
      //console.log(" STORE ID "+store_id+ " DATE APPOINT "+selected_date+ " SLOT "+slot_book + " BOOKING TYPE:: " +booking_type + " MEMBERS "+members );
      $(".confirm_member_appointment").show();
    })
     $('body').on('click','.confirm_member_appointment',function(){ 
      $(".appointment_guests").html('');
      $(".store_country").text(store_address);
      $(".store_name").text(store_name);
      $(".appointment_date").text(selected_date);
      $(".appointment_slot").text(slot_book);
      $(".members").text(members);
       
      $(".calender_slots").hide();
      if(booking_type == "slot_booking"){
        var book_guest_html='';
       
        var index=0;
        if(members > 1){
         var cnt=1;
          $(".else-come").show();
          for(var i=2;i<=members;i++){
            book_guest_html+='<div class="optional"><h2 class="guest-h2-1 pb-0">GUEST '+cnt+' (OPTIONAL)</h2></div>';
            book_guest_html+='<div class="email"><input type="text"  name="guest['+index+'][email]" placeholder="EMAIL"></div>';
            book_guest_html+='<div class="first  mb-3">';
            book_guest_html+='<div class="name-first name-first-1"><div class="first-name"><input type="text"  name="guest['+index+'][first_name]" placeholder="First Name"></div></div>';
            book_guest_html+='<div class="name-first"><div class="first-name"><input type="text"  name="guest['+index+'][last_name]" placeholder="Last Name"></div></div>';
            book_guest_html+='</div>';  
            cnt++;
            index++;
          }
          $(".appointment_guests").html(book_guest_html);
          
        }else{
          $(".else-come").hide();
        }
        
      }
      $(".calender_slots_form_submit").show();
      target_scroll('calender_slots_form_submit');
    });

$('#appointment_direct_form').validate({
    rules: {
        book_direct_email: {
            required: true               
        },
      book_direct_member: {
            required: true,
            max: function(){ return $("#direct_member").val();}
        },
        book_direct_first_name:"required",
        book_direct_last_name:"required",
        book_direct_country_code:"required",     
        book_direct_mobile:"required",
        book_direct_date_flexible:"required",
        book_direct_member:"required",
        book_direct_date_flexible:"required",
        book_direct_date_inperson:"required",
        book_direct_occasioin:"required",
        address_confirm: {
          required: true
        }
    }, 
    messages: {
        book_direct_email: {
            required: "Please enter valid email"                
        },
      book_direct_member: {
            required: "Please enter valid members",
            //max:"Member number must be greater then or equal 7"
        },
        book_direct_first_name:"First Name Required",
        book_direct_last_name:"Last Name Required",
        address_confirm: "Please select and confirm the store location"
    },
    errorPlacement: function (error, element) {
      if (element.attr("name") === "address_confirm") {
        // Place error message directly below the checkbox options
        error.appendTo(element.closest(".booking-checkbox"));
      } else {
        error.insertAfter(element);
      }
    }
});

    $("#direct_form_bulk").click(function(){
      if ($("#appointment_direct_form").valid()) {
        $(".appoitment_form_loading").show();
          var form = $('#appointment_direct_form'); 
          form.append('<input type="hidden" name="store_id" value="'+store_id+'">');
         
           $.ajax({
              type: 'POST',
              url: 'http://bookingbeautytailornyc.com/set-appointment-direct',
              //url: 'http://127.0.0.1:8000/set-appointment-direct',
              dataType: 'json',
              crossDomain: true, 
              data:$('#appointment_direct_form').serialize(),
              dataType: 'json',            
             success: function(responseData, textStatus, jqXHR) {
                $(".appoitment_form_loading").hide();
                 $(".form_appointment_container").hide();
                  $(".google_event").prop('href',responseData.response.google_event_link)
                  $(".apple_event").prop('href',responseData.response.apple_event_link)
                  $(".confirm_store_address").text(responseData.response.store_address_info)
                  $(".confirm_customer_email").text(responseData.response.customer_email)
                  $(".complete_form_direct").show();
               
                target_scroll('complete_form_direct');
              },
              error: function (responseData, textStatus, errorThrown) {
                $(".appoitment_form_loading").hide();
                  // alert('Something went wrong, please try after some time.');
                $(".direct_form_error_notifications").text('Something went wrong, please try with valid information.');
              }
           })
      }else{
        target_scroll('direct_appointment_form');
      }
      
        
    });

$('#appointment_form').validate({
    rules: {
        book_email: {
            required: true               
        },
        book_first_name:"required",
        book_last_name:"required",
        book_country_code:"required",           
        book_mobile:"required",
        address_confirm: {
          required: true
        },
        'guest[]': {
            required: true
        },          
          
    }, 
    messages: {
        book_email: {
            required: "Please enter valid email"                
        },
        book_first_name:"First Name Required",
        book_last_name:"Last Name Required",
        address_confirm: "Please confirm the store location"
    },
    errorPlacement: function(error, element) {
      if (element.attr("name") === "address_confirm") {
        // Appends error message below the entire checkbox section
        error.appendTo(element.closest(".booking-checkbox"));
      } else {
        error.insertAfter(element);
      }
    }
});

$(".appointment_form_submit_confirm").click(function(e){
     if ($("#appointment_form").valid()) {
        $(".appoitment_form_loading").show();
            var form = $('#appointment_form');          
            form.append('<input type="hidden" name="appointment_date" value="'+selected_date+'">');
            form.append('<input type="hidden" name="members" value="'+members+'">');
            form.append('<input type="hidden" name="slot" value="'+slot_book+'">');
            form.append('<input type="hidden" name="store_id" value="'+store_id+'">');
            
           var params = $('#appointment_form input,select, checkbox, textarea').serializeArray();
            params = serializeToJson(params);
             $.ajax({
                type: 'POST',
                url: 'http://bookingbeautytailornyc.com/set-appointment-slot',
                //url: 'http://127.0.0.1:8000/set-appointment-slot',
                dataType: 'json',
                crossDomain: true, 
                data:$('#appointment_form').serialize(),
                dataType: 'json',            
               success: function(responseData, textStatus, jqXHR) {
                  $(".google_event").prop('href',responseData.response.google_event_link)
                  $(".apple_event").prop('href',responseData.response.apple_event_link)
                  $(".confirm_store_address").text(responseData.response.store_address_info)
                  $(".confirm_customer_email").text(responseData.response.customer_email)
                  $(".appoitment_form_loading").hide();
                  $(".calender_appointment_container").hide();
                  $(".complete_form").show();
                  target_scroll('complete_form');
                },
                error: function (responseData, textStatus, errorThrown) {
                  $(".appoitment_form_loading").hide();
                    // alert('Something went wrong, please try with valid information.');
                  $(".direct_form_error_notifications").text('Something went wrong, please try with valid information.')
                }
             })
      }else{
        target_scroll('appoitment_form');
      }  
    });

    function serializeToJson(serializer){
        var _string = '{';
        for(var ix in serializer)
        {
            var row = serializer[ix];
            _string += '"' + row.name + '":"' + row.value + '",';
        }
        var end =_string.length - 1;
        _string = _string.substr(0, end);
        _string += '}';
        console.log('_string: ', _string);
        return JSON.parse(_string);
    }        

    function getSlots(){
      $(".calender_slots").show();
        $(".time_calander").show();
        $(".time_calander").html('<div class="loader"><img src="https://cdn.shopify.com/s/files/1/0276/6287/6790/files/loading.gif?v=1658397023"></div>');
       $.ajax({
        type:'get',
        url:'http://bookingbeautytailornyc.com/get-store-availability?store_id='+store_id+'&date='+selected_date,
        success: function (result, status, xhr) { 
          var list_get = result.slots;
          var html='';        
          if(list_get.length > 0){
            for(let i=0;i<list_get.length; i++){
                if(list_get[i].available == "1"){
                  html+='<div class="list-1"><label class="slots_input" data-slot="'+list_get[i].slot+'">'+list_get[i].slot+'</label> </div>';
                }else{
                  html+='<div class="list-1 disable_hours"><label class="booked_slot" data-slot="'+list_get[i].slot+'">'+list_get[i].slot+'</label> </div>';
                }
            }
            $(".time_calander").html(html);
          }else{
            $(".time_calander").html('<div class="notfound">No appointment available</div>');
          }
        }
       });
    }
    
    
    function getstoreinfo(){
      $('.store_inner').html('<div class="loader"><img src="https://cdn.shopify.com/s/files/1/0276/6287/6790/files/loading.gif?v=1658397023"></div>');
      $.ajax({
      type:'get',
      url:'http://bookingbeautytailornyc.com/get-store-information',
      success: function (result, status, xhr) {        
        var list_get = result.data;
        var html='';        
        if(list_get.length > 0){
          for(let i=0;i<list_get.length; i++){
            html+='<div class="store_location" id="'+list_get[i].id+'" >';
            html+='<div class="stores_list" style="display:none;">';
            html+='<button class="accordion">'+list_get[i].country+': The Beauty Talior</button>';
            
            html+='<div class="panel">';
            html+='<h2 class="panel-1 ">Address</h2>';
            html+='<h2 class="panel-2 store_address">'+list_get[i].address+' </h2>';
            html+='<h2 class="panel-3 ">Opening Hours</h2>';
            html+='<div class="storelocation store-hours"> ';
           
            html+=list_get[i].opening_hours;
            html+='</div>';
            html+='<div>';
            html+='<iframe class="store_location" src="'+list_get[i].google_address+'" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>';
            //html+='<iframe src="https://maps.google.com/maps?width=100%&amp;height=600&amp;hl=en&amp;q='+list_get[i].google_address+';t=&amp;z=14&amp;iwloc=B&amp;output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" width="100%" height="600" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe><br />';
            html+='</div>';
            
            html+='<div class="confirm first_point_confirm">  ';
            html+='<a href="javascript:void(0);" data-id="'+list_get[i].id+'" data-store="'+list_get[i].store_name+'" data-storeaddress="'+list_get[i].address+'" data-storecountry="'+list_get[i].country+'"  class="confirm-btn confirm_store">Confirm</a>';
            html+='</div>';
            html+='</div>';
            html+='</div>';

            /**Calender Content Set***/
            $(".pick-title").text(list_get[i].CalenderTitle);
            $(".pick_content").html(list_get[i].CalenderContent);
            allowedDay = list_get[i].customDateOpen;
            //console.log(allowedDay)
            
            /***Reload Date */               
            $("#datepicker").datepicker("refresh");       
            /**End reload Date */

            /******PREFF TIME SET*******/

            $('.timepicker').timepicker({
                timeFormat: 'h:mm p',
                interval: 30,
                minTime: list_get[i].party_start,
                maxTime: list_get[i].party_end,
                defaultTime: '11',
                startTime: list_get[i].party_start,
                dynamic: false,
                dropdown: true,
                scrollbar: true
            });

            store_id = list_get[i].id;
            store_name = list_get[i].store_name;
            store_address = list_get[i].country +": "+ list_get[i].address + ", "+list_get[i].city + ", "+list_get[i].state;
            
            if(list_get[i].booking.length > 0){
              $('.confirm_store').trigger('click');
            /****Tabs container*****/  
            html+='<section class="lab" id="store_id_'+list_get[i].id+'" data-storeid="'+list_get[i].id+'" style="display:block;">';
            
            html+='<div>';
            html+='<h2 class="h2-title">'+list_get[i].MainTitle+'</h2>';
            html+=list_get[i].MainSubTitle;                
            html+='</div>';

            html+='<div class="multi-step-nav">';
            html+='<div class="step step-1 active">1</div>';
            html+='<div class="step step-2">2</div>';
            html+='<div class="step step-3">3</div>';
            html+='</div>';
            
            html+='<div>';
            html+='<div class="who-coming">';
            html += '<div class="who-coming-no-heading">Select Number of Guests</div>';
            html+='<div class="who-coming-row">';
            
            
            /***Repeat items***/
            for(let b=0; b<list_get[i].booking.length; b++){  
              var bookingItem = list_get[i].booking[b];

              // 1. Skip / Hide the "1" box completely
              if (bookingItem.total_numbers == 1 || bookingItem.label == "1") {
                continue; 
              }

              // 2. Change the label "2-4" to "1-4"
              var displayLabel = bookingItem.label;
              if (displayLabel == "2-4") {
                displayLabel = "1-4";
              }

              var is_discription = 0;
              if(bookingItem.description != null){
                is_discription = 1;
                html += '<div class="box-information-container box-related-'+bookingItem.total_numbers+'" style="display:none;">';
                html += bookingItem.description;
                html += '</div>';
              }

              /*** Dropdown generation (starts from 1 up to total_numbers) ***/
              if(bookingItem.appointment_type == 1 ){
                if(bookingItem.total_numbers > 1){   
                  html += '<div class="dropdown_member_select_container">';
                  html += '<select class="select-udi udi-select number_guest_info" style="display:none;">';
                  html += '<option value="">Guests</option>';
                  for(let c = 1; c <= bookingItem.total_numbers; c++){
                    html += '<option value="'+c+'">'+c+'</option>';
                  }
                  html += '</select>';
                  html += '</div>';
                } 
              }

              // Render the button card
              html += '<div class="who-coming-col comming_modules" data-type="'+bookingItem.appointment_type+'" data-discription="'+is_discription+'" data-numbers="'+bookingItem.total_numbers+'">';
              html += '<div class="who-coming-title who-coming-color">';
              html += '<h2 class="who-coming-number">'+displayLabel+'</h2>';
              html += '</div>';
              html += '<div class="heading-p ">';
              html += '<p>'+(bookingItem.title || '')+'</p>';
              html += '</div>';
              if(bookingItem.sub_title != null){
                html += '<div class="heading-p-sub">';
                html += '<p>'+bookingItem.sub_title+'</p>';
                html += '</div>';
              }
              html += '</div>';

              if(bookingItem.appointment_type == 1 ){
                /***Simple form content add****/
                $(".form_simple_heading").append('<h2 class="almost-heading formtype formtype_'+bookingItem.total_numbers+'">'+bookingItem.FormTitle+'</h2>');
                $(".form_simple_box").append('<div class="formtype formtype_'+bookingItem.total_numbers+'">'+bookingItem.FormSubTitle+'</div>');
                $('.form_simple_second').append('<h2 class="formtype tell-us formtype_'+bookingItem.total_numbers+'">'+bookingItem.FormSecondTitle+'</h2>');
                $(".form_simple_second").append('<div class="formtype formtype_'+bookingItem.total_numbers+'">'+bookingItem.FormSecondContent+'</div>');
              } else {
                var direct_title_content = '';
                direct_title_content += "<h2>"+bookingItem.FormTitle+"</h2>";
                direct_title_content += bookingItem.FormSubTitle;
                if(bookingItem.FormSecondTitle != null){
                  direct_title_content += bookingItem.FormSecondTitle;
                }
                if(bookingItem.FormSecondContent != null){
                  direct_title_content += bookingItem.FormSecondContent;
                }
                
                $("#appointment_direct_content").html(direct_title_content);
                $(".direct_form_bottom_content , .bottom_content").html(bookingItem.FormBottomContent);
              }
            }
            /***End Repeat items***/
            
            html+='</div>';
            html+='</div>';
            html+='</div>';
            html+='<div class="confirm-button-container confirm_member_container" >';
            html+='<a href="javascript:void(0);" data-id="'+list_get[i].id+'" class="confirm-btn confirm_member confirm_member_container_first" style="display:none">Confirm</a>';
            //html+='<a href="javascript:void(0);" data-id="'+list_get[i].id+'" class="back-btn back_member_first" style="display:none">Back</a>'; 
            html+='</div>';            
            html+='</section>';
            /****End Tabs container*****/   
            
            /****Calender container*****/
              
            /****END Calender container*****/
              
            /****Form container*****/
              
            /****END Form container*****/
              
            }
            html+='</div>';
          }
          $(".store_inner").html(html);
          target_scroll('stores_list');


          setTimeout(function(){
            var urlHash = window.location.hash.replace('#', '');
            
            var planMapping = {
              'solo': '4',
              'group': '4',
              'party': '10'
            };
            
            var planNumber = planMapping[urlHash] || urlHash;
            
            var $targetTab = $(".who-coming-col[data-numbers='" + planNumber + "']");
            if($targetTab.length){
              $targetTab.trigger('click');
              $('html, body').animate({
                scrollTop: $('#booking-steps').offset().top - 0
              }, 500);
            }
          }, 300);


                           
        }
      }
      
    });
    }
    
    $("body").on('click','.store_location',function(){
    	var $this = $(this);      
        $this.children().children('.panel').removeClass('active');
        $this.children().children('.panel').addClass('active');
    });

    $('body').on('click', '.who-coming-col', function () {
      $('.who-coming-col').removeClass('highlight'); 
      $(this).addClass('highlight'); 
    });

  });